/* file description */
// import { compose } from '@cui/corteza-js';
import { getAssetModuleJson, getAssetModuleRecord, getModuleRecordList, getAllUser } from './assetModel';
import moduleMapAsset from '@/common/asset-apis/useModelMapAseet';
import { LCP_FIELD_KINDS } from '@/components/SEFieldWithModel/effects/consts';
import _ from 'lodash';
import { ModuleInfo } from '../model-apis/type';
import { promiseCacher } from '@cui/lcp-tools';
import { notify } from '@/utils';

const COMPONENTS_TYPE_MAPPING: any = [
  ['textinput', LCP_FIELD_KINDS.STRING],
  ['datetime', LCP_FIELD_KINDS.ASSET_DATETIME],
  ['textarea', LCP_FIELD_KINDS.TEXT],
  ['treeselect', LCP_FIELD_KINDS.REFERENCE],
  ['select', LCP_FIELD_KINDS.REFERENCE],
  ['qrcode', LCP_FIELD_KINDS.QRCODE],
  ['areaselect', LCP_FIELD_KINDS.AREA_SELECT],
  ['checkbox', LCP_FIELD_KINDS.ASEET_CHECKBOX],
  ['radio', LCP_FIELD_KINDS.ASEET_RADIO],
  ['number', LCP_FIELD_KINDS.NUMBER],
  ['boolen', LCP_FIELD_KINDS.ASSET_BOOL],
  ['role', LCP_FIELD_KINDS.BOULDERAI_ROLE],
  ['user', LCP_FIELD_KINDS.BOULDERAI_USER],
  ['depuser', LCP_FIELD_KINDS.DEPUSER],
  ['file', LCP_FIELD_KINDS.FILE],
  ['productselect', LCP_FIELD_KINDS.PRODUCTSELECT],
  ['openapiselect', LCP_FIELD_KINDS.OPENAPI_SELECT],
  // ['timestamp', LCP_FIELD_KINDS.DATE_TIME],
  // ['integer', LCP_FIELD_KINDS.STRING],
  // ['json', LCP_FIELD_KINDS.STRING],
];

// 将基础组件类型转化为kind类型
export const transformComponentsTypeToKind = (componentsType: string) => {
  const map = new Map(COMPONENTS_TYPE_MAPPING);
  const kind = map.get(componentsType);
  if (!kind) {
    notify.warn(notify.Type.DataError, `基础组件 ${componentsType} 未找到`);
  }
  return kind;
};

export const customizer = (objValue: any, srcValue: any) => {
  if (_.isArray(objValue)) {
    return srcValue;
  }
};

interface GetModuleByRequestProps {
  FetchAPI?: any;
  namespaceID: string;
  moduleID: string;
  assetModuleInfo?: ModuleInfo;
}

let BizComponentsMaps = {};

const getBizComponentsMap = promiseCacher(async ({
  FetchAPI,
}: any) => {
  // 获取业务组件列表
  const bizComponets = await getModuleRecordList(
    FetchAPI,
    'tech',
    'bizz_components_config',
    { limit: 1000 },
  );

  // 生成业务组件id与配置映射表
  const bizComponetsIdOptionMap: { [id: string]: { kind: any; options: any } } = {};
  bizComponets.set.forEach((set: { values: any[] }) => {
    const options = set.values.find((v) => v.name === 'options').value;
    // try {
    //   options = JSON.parse(options || '{}')
    // } catch (e) {
    //   options = {};
    // }
    const componentsType = set.values.find((v) => v.name === 'components_type').value;
    const code = set.values.find((v) => v.name === 'code').value;
    const kind = transformComponentsTypeToKind(componentsType) || LCP_FIELD_KINDS.STRING;
    bizComponetsIdOptionMap[code] = {
      kind,
      options,
    };
  });
  BizComponentsMaps = bizComponetsIdOptionMap;
  return bizComponetsIdOptionMap;
});

// 基于code获取业务组件参数，强制依赖业务组件的第一次获取
export const getBizConfig = (bizComponentCode: string) => {
  return BizComponentsMaps[bizComponentCode];
};

export const getAssetModuleByRequest = async ({
  FetchAPI,
  namespaceID,
  moduleID,
  assetModuleInfo,
}: GetModuleByRequestProps) => {
  const { transformAssetFieldType } = moduleMapAsset();
  let res = assetModuleInfo || await getAssetModuleJson(FetchAPI, namespaceID, moduleID);
  // 拷贝一份数据，保证后续变更及返回的数据为副本,否则执行两次会导致kind未找到
  res = _.cloneDeep(res);
  res.fields = res.fields.map((item: any) => {
    return { ...item, kind: transformAssetFieldType(item.kind) };
  });

  // 业务组件id与配置映射表
  const bizComponetsIdOptionMap: { [id: string]: { kind: any; options: any } } = await getBizComponentsMap({ FetchAPI });

  const requestList: any[] = [];
  // 数据匹配映射
  res?.fields.forEach((field: {
    name: string;
    label: string;
    componentsCode: string;
    kind: any;
    options: any;
    bizConfig: any;
    extension: any;
    defaultValue: any;
    isEditable: boolean;
    isDisabled: boolean;
  }) => {
    // 基于业务组件类型重新定义kind
    if (field?.componentsCode) {
      const cfg = bizComponetsIdOptionMap[field.componentsCode];
      if (!cfg) {
        console.error(`${field.label}#${field.name} componentsCode(${field.componentsCode}) 未定义，请检查业务组件配置`, field);
        return;
      }
      field.kind = cfg.kind;
      field.bizConfig = _.mergeWith({}, cfg.options, field.options?.componentsOptions, customizer);
      field.options = _.mergeWith({}, cfg.options, field.options, field.options?.componentsOptions, customizer);
      // prefilter拼接
      if (!field.bizConfig.prefilter && field.bizConfig.filterField && field.bizConfig.filterFieldValue) {
        field.bizConfig.prefilter = `${field.bizConfig.filterField} = '${field.bizConfig.filterFieldValue}'`;
      }
      // 用户类型字段塞入用户数据
      if (['BoulderaiUser', 'DepUser'].includes(field.kind)) {
        const p = new Promise((resolve) => {
          resolve(
            getAllUser(FetchAPI).then((userRes) => {
              field.bizConfig.userList = userRes;
            }),
          );
        });
        requestList.push(p);
      }
    }
    // 默认值和是否可编辑处理，目前先存放在 extension
    field.extension = Object.assign({}, field.extension, {
      defaultValue: field.defaultValue,
      isDisabled: !field.isEditable, // 在useGetColumnByField中有通用逻辑处理
      tooltip: field.options?.tooltip,
    });
    // filed.isDisabled = !filed.isEditable;
  });
  await Promise.all(requestList);
  // console.log('-----res', res)
  // console.log('-----res', new compose.Module(res))
  return res;
  // return new compose.Module(res);
};
